var map = {
	"./aparthotelclub/ic_verified_badge.svg": 25337,
	"./beachful/ic_verified_badge.svg": 96439,
	"./castlepedia/ic_verified_badge.svg": 65903,
	"./cocktayl/ic_verified_badge.svg": 68834,
	"./ic_verified_badge.svg": 18123,
	"./luxresortclub/ic_verified_badge.svg": 27793,
	"./parkful/ic_verified_badge.svg": 15796,
	"./prefabworld/ic_verified_badge.svg": 44397,
	"./rooftopclub/ic_verified_badge.svg": 29902,
	"./spaclub/ic_verified_badge.svg": 76888,
	"./worldcasino/ic_verified_badge.svg": 91600,
	"./zoopedia/ic_verified_badge.svg": 31359
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35356;